// FAQ(법률정보 칼럼) 카테고리 정의 및 분류 규칙.
//
// 백엔드 칼럼에는 카테고리 필드가 없고 해시태그도 일부 글에만 있어,
// 제목(+해시태그) 키워드 매칭으로 5개 대분류에 자동 분류한다.
// 카테고리별로 브라우저 title·H1·소개문을 다르게 노출하고(SEO),
// 상세페이지의 "관련 게시글"·"관련 업무분야(교육과정)" 연결에도 쓴다.
//
// 주의: 이 파일은 CRA(src) 전용 ES 모듈이라 CommonJS 빌드 스크립트에서
//       직접 import할 수 없다. 동일 정의가 scripts/faqCategories.cjs 에도
//       인라인으로 존재하므로 규칙을 바꾸면 두 파일을 함께 수정할 것.

// 교육과정(업무분야) 숫자 id — courseSlugMap.js 의 COURSE_ID_TO_SLUG 와 동일하게 유지.
//   67: 성범죄 재범방지교육 / 35: 양형기준의 이해 / 34: 음주운전 재범방지교육
const COURSE = {
  SEXUAL: { id: 67, slug: "sexual-offense-prevention", name: "성범죄 재범방지교육" },
  DRUNK: { id: 34, slug: "drunk-driving-prevention", name: "음주운전 재범방지교육" },
  SENTENCING: { id: 35, slug: "sentencing-guidelines", name: "양형기준의 이해" },
};

// 분류 우선순위 순서대로 나열한다(앞선 카테고리가 먼저 매칭됨).
// 예: "술에 취한 상대방과 관련된 준강제추행"은 성범죄 키워드(준강제추행)가
//     교통 키워드(술)보다 먼저 매칭되어 성범죄로 분류된다.
export const FAQ_CATEGORIES = [
  {
    slug: "sexual-offense",
    name: "성범죄",
    navLabel: "성범죄",
    title: "성범죄 법률정보·양형교육 자료 | 희망과학 심리상담센터",
    h1: "성범죄 법률정보",
    intro:
      "강제추행·통신매체이용음란·불법촬영·디지털 성범죄 등 성범죄 사건의 재발 방지 교육과 양형자료 준비 방법을 사례별로 정리했습니다.",
    metaDescription:
      "강제추행·통신매체이용음란·불법촬영·디지털 성범죄 등 성범죄 사건의 재발 방지 교육과 양형자료 준비 방법을 사례별로 확인하세요.",
    keywords: [
      "성범죄", "성추행", "강제추행", "추행", "성착취", "성 착취", "성적", "성폭력",
      "통신매체이용음란", "딥페이크", "불법촬영", "불법 촬영", "카메라등이용촬영",
      "촬영물", "그루밍", "준강간", "준강제추행", "강간", "스토킹", "화장실 침입",
      "디지털 성범죄", "신체 사진", "음란", "경계 존중", "주거침입", "13세",
    ],
    course: COURSE.SEXUAL,
  },
  {
    slug: "drug",
    name: "마약",
    navLabel: "마약",
    title: "마약 사건 법률정보·양형교육 자료 | 희망과학 심리상담센터",
    h1: "마약 사건 법률정보",
    intro:
      "마약 투약·재범 사건에서 단약 의지를 넘어선 재발 방지 자료와 양형교육 준비 방향을 안내합니다.",
    metaDescription:
      "마약 투약·재범 사건의 재발 방지 자료와 양형교육 준비 방향, 수료증·의견서 준비 방법을 확인하세요.",
    keywords: ["마약", "단약", "필로폰", "대마", "향정"],
    course: COURSE.SENTENCING,
  },
  {
    slug: "traffic",
    name: "교통",
    navLabel: "교통범죄",
    title: "교통범죄 법률정보·음주운전 양형교육 자료 | 희망과학 심리상담센터",
    h1: "교통범죄 법률정보",
    intro:
      "음주운전·무면허·음주측정거부 등 교통범죄 사건의 재범 방지 교육과 양형자료 준비 방법을 사례별로 안내합니다.",
    metaDescription:
      "음주운전·무면허·음주측정거부 등 교통범죄 사건의 재범 방지 교육과 양형자료 준비 방법을 확인하세요.",
    keywords: [
      "음주운전", "무면허", "음주측정", "전동킥보드", "킥보드", "대리운전",
      "교통사고", "음주사고", "면허취소", "면허 취소", "낮술", "음주 ",
    ],
    course: COURSE.DRUNK,
  },
  {
    slug: "property-fraud",
    name: "재산·사기",
    navLabel: "재산·사기",
    title: "재산·사기 사건 법률정보·양형교육 자료 | 희망과학 심리상담센터",
    h1: "재산·사기 사건 법률정보",
    intro:
      "사기·절도·횡령·배임·보이스피싱·도박 등 재산범죄 사건의 피해 회복과 양형자료 준비 기준을 안내합니다.",
    metaDescription:
      "사기·절도·횡령·배임·보이스피싱·도박 등 재산범죄 사건의 피해 회복과 양형자료 준비 기준을 확인하세요.",
    keywords: [
      "사기", "절도", "횡령", "배임", "장물", "보이스피싱", "도박",
      "투자사기", "계좌를 빌려", "재물손괴",
    ],
    course: COURSE.SENTENCING,
  },
  {
    slug: "general-criminal",
    name: "일반형사",
    navLabel: "일반형사",
    title: "일반형사 사건 법률정보·양형교육 자료 | 희망과학 심리상담센터",
    h1: "일반형사 법률정보",
    intro:
      "폭행·명예훼손·공무집행방해·업무방해·학교폭력 등 형사사건의 재발 방지 교육과 양형자료 준비 방향을 안내합니다.",
    metaDescription:
      "폭행·명예훼손·공무집행방해·업무방해·학교폭력 등 형사사건의 재발 방지 교육과 양형자료 준비 방향을 확인하세요.",
    keywords: [
      "폭행", "학교폭력", "공무집행방해", "업무방해", "명예훼손", "무고",
      "개인정보", "위증", "증거인멸", "협박",
    ],
    course: COURSE.SENTENCING,
  },
];

// slug → 카테고리 객체
export const FAQ_CATEGORY_BY_SLUG = FAQ_CATEGORIES.reduce((acc, c) => {
  acc[c.slug] = c;
  return acc;
}, {});

/**
 * 게시글의 제목(+해시태그)으로 카테고리 slug를 판정한다. 매칭 없으면 null.
 * @param {string} title  게시글 제목
 * @param {string} [hashtags]  해시태그 원본 문자열(공백 구분)
 * @returns {string|null} 카테고리 slug
 */
export function classifyColumnCategory(title, hashtags = "") {
  const haystack = `${title || ""} ${hashtags || ""}`;
  for (const category of FAQ_CATEGORIES) {
    if (category.keywords.some((kw) => haystack.includes(kw))) {
      return category.slug;
    }
  }
  return null;
}

// 카테고리를 못 찾은 글(양형교육 절차·수료증 공통 안내 등)의 관련 업무분야 폴백.
export const DEFAULT_RELATED_COURSE = COURSE.SENTENCING;
